//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.MultipleObjectsBuilder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../AME/AME.SelectClassificationBuilder.js";
import "../AME/AME.SelectionEngineeringObjectDefinitionBuilder.js";
import "../AME/AME.SelectionBaseDefinitionBuilder.js";
import "../no/SelectObject.js";
let d=[[[0,"AllAspects",1,0],[0,"AspectOperator",1,0],[0,"CableAssignmentOperator",1,0],[0,"CableAssignmentValue",1,0],[0,"ClassificationOperator",1,0],[0,"ClauseOperatorType",1,0],[0,"ConditionType",1,0],[0,"ConnectedValue",1,0],[0,"MathOperator",1,0],[0,"NumberOfConnectedPorts",1,0],[0,"ParentPropertySelectedAspect",1,0],[0,"PortCondition",1,0],[0,"PortDomain",1,0],[0,"ProductAssigmentOperator",1,0],[0,"ProductAssigmentValue",1,0],[0,"PropertyAppliedTo",1,0],[0,"PropertyOfCategory",1,0],[0,"ReuseLibraryOperator",1,0],[1,"SelectAspect",0,"AME.SelectAMEBaseNode",0],[1,"SelectClassification",0,"AME.SelectClassificationBuilder",0],[1,"SelectFromMemberSelect",0,"AME.SelectionEngineeringObjectDefinitionBuilder",1],[1,"SelectLibraryObject",0,"AME.SelectionBaseDefinitionBuilder",0],[0,"SelectedQuery",1,"AME.AMEQuery",0],[0,"SelectedQueryClause",1,"AME.QueryClause",0],[0,"SubType",1,0],[0,"Type",1,0],[0,"ValueCount",1,0]],[[["index","propertyName"],"SetProperty",{},2,0],[["index","propertyOperator"],"SetPropertyOperator",{},2,0],[["index","propertyValue"],"SetPropertyValue",{},2,0],[["classificationPropertyID"],"SetClassificationPropertyId",{},1,0],[["index","classificationPropertyID"],"SetClassificationPropertyIdAt",{},2,0]],[]];
SPLM.AME.EditClauseBuilder = class extends SPLM.AME.MultipleObjectsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.EditClauseBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.EditClauseBuilder.Types = Object.freeze({
    "Classification" : "Classification", "LibraryObject" : "LibraryObject", "Aspect" : "Aspect", "Property" : "Property", "Port" : "Port", "ProductAssignment" : "ProductAssignment", "ParentProperty" : "ParentProperty", "CableAssignment" : "CableAssignment"});

SPLM.AME.EditClauseBuilder.Operator = Object.freeze({
    "As" : "As", "Under" : "Under", "OfType" : "OfType"});

SPLM.AME.EditClauseBuilder.QueryClauseOperatorType = Object.freeze({
    "And" : "And", "Or" : "Or", "None" : "None"});

SPLM.AME.EditClauseBuilder.QueryPropertyAppliedTo = Object.freeze({
    "Classification" : "Classification", "LibraryObject" : "LibraryObject", "Aspect" : "Aspect", "General" : "General", "Tag" : "Tag"});

SPLM.AME.EditClauseBuilder.QueryPropertyOfCategory = Object.freeze({
    "FunctionAspect" : "FunctionAspect", "LocationAspect" : "LocationAspect", "ProductAspect" : "ProductAspect"});

SPLM.AME.EditClauseBuilder.QueryPropertyOfClassLibCategory = Object.freeze({
    "Type" : "Type", "Product" : "Product"});

SPLM.AME.EditClauseBuilder.MathOperatorsType = Object.freeze({
    "IsEqual" : "IsEqual", "IsNotEqual" : "IsNotEqual", "IsGreaterThanOrEqual" : "IsGreaterThanOrEqual", "IsGreaterThan" : "IsGreaterThan", "IsLessThanOrEqual" : "IsLessThanOrEqual", "IsLessThan" : "IsLessThan"});

SPLM.AME.EditClauseBuilder.QueryPortCondition = Object.freeze({
    "Exists" : "Exists", "IsConnected" : "IsConnected"});

SPLM.AME.EditClauseBuilder.QueryConnectedValue = Object.freeze({
    "True" : "True", "False" : "False"});

SPLM.AME.EditClauseBuilder.ProductAssignmentOperator = Object.freeze({
    "Equal" : "Equal", "NotEqual" : "NotEqual"});

SPLM.AME.EditClauseBuilder.ProductAssignmentValue = Object.freeze({
    "True" : "True", "False" : "False"});

SPLM.AME.EditClauseBuilder.ParentPropertyAspect = Object.freeze({
    "FunctionAspect" : "FunctionAspect", "LocationAspect" : "LocationAspect", "ProductAspect" : "ProductAspect", "AutomationAspect" : "AutomationAspect"});

SPLM.AME.EditClauseBuilder.CableAssigmentOperator = Object.freeze({
    "Equal" : "Equal"});

SPLM.AME.EditClauseBuilder.CableAssigmentValue = Object.freeze({
    "True" : "True", "False" : "False"});

export default SPLM;